import React from 'react';
import { APITypes } from '../../../../../primary-record-types';
import MedicalProfileFileAudioPlayer from '../../../../shared/AudioPlayer/MedicalProfileFileAudioPlayer';
import Stack from '../../../../v2BaseComponents/Stack';

export type SearchResultAudioDisplayOwnProps = {
    audioSearchResult: APITypes.medicalProfileFilesService.MedicalProfileFileAudioSearchItem;
    medicalProfileId: string;
    showDetailedResult: boolean;
};

export type SearchResultImageDisplayProps = SearchResultAudioDisplayOwnProps;

const SearchResultImageDisplay: React.FC<SearchResultImageDisplayProps> = (props) => {
    return (
        <Stack horizontal justify="center" fullWidth>
            <MedicalProfileFileAudioPlayer
                medicalProfileId={props.medicalProfileId}
                medicalProfileFileId={props.audioSearchResult.medicalProfileFileId}
                startTime={props.audioSearchResult.startTime}
                endTime={props.audioSearchResult.endTime}
            />
        </Stack>
    );
};

export default React.memo(SearchResultImageDisplay);
